export function getParams (state){
    return state.params
}

export function parameters(state) {
   return 'ok'
}



// WEBPACK FOOTER //
// ./src/modules/parameters/getters.js